import NewsCard from '@/components/base/NewsCard';
import SectionHeading from '@/components/base/SectionHeading';
import { getLatestArticles } from '@/utils/content';

export default function LatestSection() {
  const latest = getLatestArticles(6);

  return (
    <section className="px-4 md:px-6 py-12 md:py-16" aria-labelledby="home-latest">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Fresh Melon"
          title="新瓜速递"
          desc="刚刚更新的一批内容，按发布时间从新到旧排列。来不及全看，可以先挑标题有意思的点进去。"
          href="/news"
          hrefLabel="查看全部"
        />
        <h2 id="home-latest" className="sr-only">
          新瓜速递
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <NewsCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}